export default __webpack_public_path__ + "static/media/ic-warning.0b86405b.svg";